<template>
    <div
      class="
        $typography/size:medium
        layout/border:3pt
        layout/height:baseline:3
        layout/relative
        layout/width:100%
      "
      >
      <div
        class="
          layout/align:center
          layout/flex
          layout/height:100%
          layout/padding:cap
        "
        >
        <select
          :id="id"
          v-model="selectedValue"
          :aria-label="ariaLabel"
          :name="name"
          class="
            layout/absolute
            layout/bottom:0%
            layout/left:0%
            layout/margin:clear
            layout/opacity:0%
            layout/right:0%
            layout/top:0%
            layout/width:100%
            typography
          "
          >
          <template v-for="option in options">
            <optgroup
              v-if="option.group"
              :key="`option-group-${option.group}`"
              :label="showGroupLabel ? option.group : ''"
              >
              <option
                v-for="(opt, idx) in option.options"
                :key="`option-${idx}`"
                :value="opt.value"
                v-html="opt.label"
              />
            </optgroup>
            <option
              v-else
              :key="`option-${option?.label ?? option}`"
              :value="option?.value ?? option"
              :disabled="option?.disabled"
              >
              {{ option?.label ?? option }}
            </option>
          </template>
        </select>
        <label
          :for="id"
          class="
            layout/align:center
            layout/flex
            layout/justify:between
            layout/width:100%
            link/disable
          "
          >
          <p
            class="typography"
            :class="[truncateLabel ? 'typography/truncate' : '']"
            v-html="selectedLabel"
          />
          <div
            aria-hidden="true"
            class="typography/icon:90deg"
            >
            <Icon
              icon-name="icon__caret--16--stroke.svg"
              class-name="color/black"
            />
          </div>
        </label>
      </div>
    </div>
</template>

<script>
import Icon from "../icons/icon.vue";

export default {
  components: { Icon },
  props: {
    ariaLabel: { type: String, default: "" },
    id: { type: String, default: "" },
    name: { type: String, default: "" },
    options: { type: Array, required: true },
    showGroupLabel: { type: Boolean, default: false },
    truncateLabel: { type: Boolean, default: false },
    value: { type: null, required: true }
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  computed: {
    withOptionGroup() {
      if (!(this.options[0] instanceof Object)) return false;
      return this.options.some(obj => 'group' in obj);
    },
    flattenedGroupOptions() {
      return this.options.flatMap(group => group.options);
    },
    /**
     * Returns label for selected option.
     * 
     * If option is a part of an option group, flatten option groups first, then return value keyed by "label".
     * If option is an array of objects, find selected option and return value keyed by "label".
     * If option is an arary of primitive, find selected option by primitive value.
     */
    selectedLabel() {
      const selectedOption = this.withOptionGroup
        ? this.flattenedGroupOptions.find(option => option.value === this.selectedValue)
        : this.options.find(option => (option?.value ?? option) === this.selectedValue);

      if (!selectedOption) return;

      return selectedOption?.label ?? selectedOption;
    },
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    },
    selectedValue(newValue) {
      this.$emit('input', newValue);
    },
  }
};
</script>
